;var assign;
((assign = require("./selection"), exports.Selection = assign.Selection, exports.TextSelection = assign.TextSelection, exports.NodeSelection = assign.NodeSelection, exports.isSelectable = assign.isSelectable))

exports.EditorTransform = require("./transform").EditorTransform

exports.EditorState = require("./state").EditorState

;var assign$1;
((assign$1 = require("./plugin"), exports.Plugin = assign$1.Plugin, exports.PluginKey = assign$1.PluginKey))



//////////////////
// WEBPACK FOOTER
// ../~/prosemirror-state/dist/index.js
// module id = 32
// module chunks = 0